import { makeStyles } from '@mui/styles';

export const useStyles = makeStyles((theme) => ({
  menuItemWrapper: {
    position: 'relative',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: 0,
  },
  menuItemIconOnly: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: 48,
    cursor: 'pointer',
    transition: 'all 0.2s ease-in-out',
    color:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.7)'
        : 'rgba(0, 0, 0, 0.7)',
    '&:hover': {
      backgroundColor:
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.08)'
          : 'rgba(0, 0, 0, 0.04)',
      color: theme.palette.mode === 'dark' ? '#ffffff' : '#000000',
    },
    '& svg': {
      fontSize: 24,
    },
  },
  menuItemSelected: {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.12)'
        : 'rgba(0, 0, 0, 0.08)',
    color: theme.palette.mode === 'dark' ? '#ffffff' : '#000000',

    '&:before': {
      content: '""',
      width: '4px',
      height: '100%',
      position: 'absolute',
      left: 0,
      background: theme.palette.purple.main,
    },
  },
  menuItemHovered: {
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.12)'
        : 'rgba(0, 0, 0, 0.08)',
    color: theme.palette.mode === 'dark' ? '#ffffff' : '#000000',
  },
  nestedMenuItem: {
    marginBottom: 4,
    padding: '12px 16px',
    cursor: 'pointer',
    '&:hover': {
      backgroundColor:
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.08)'
          : 'rgba(0, 0, 0, 0.04)',
    },
    '&:last-child': {
      marginBottom: 0,
    },
  },
  nestedMenuIcon: {
    minWidth: 32,
    color:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.7)'
        : 'rgba(0, 0, 0, 0.7)',
    '& svg': {
      fontSize: 20,
    },
  },
  nestedMenuText: {
    '& .MuiListItemText-primary': {
      fontSize: 14,
      fontWeight: 500,
      color:
        theme.palette.mode === 'dark'
          ? 'rgba(255, 255, 255, 0.9)'
          : 'rgba(0, 0, 0, 0.9)',
    },
  },
  sectionSeparator: ({ menuOpen }) => ({
    margin: menuOpen ? 0 : '20px 5px',
    backgroundColor:
      theme.palette.mode === 'dark'
        ? 'rgba(255, 255, 255, 0.12)'
        : 'rgba(0, 0, 0, 0.12)',
  }),
  menuCollapsedContainer: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  topMenuSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  bottomMenuSection: {
    display: 'flex',
    flexDirection: 'column',
    paddingTop: 8,
  },
}));
